module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Acesso bloqueado",
      "icone": "fa fa-hand-paper-o",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "Você não possui acesso a essa página.\n\t\tVerifique suas permissões de acesso com seu superior."
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-566d415f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/sem-acesso/index.vue
// module id = 2VWi
// module chunks = 5